import React from "react";
export default function EnrollStudents() {
  return (
    <div className="dashboard-wrapper">
      <h2>Enroll / Promote Students</h2>
      <p>Here you can enroll new students or promote existing ones to the next year.</p>
      {/* Implement enrollment/promotion form here */}
    </div>
  );
}